// @core/api/endpoints/platform/update_federation_peer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FederationPeerResponse,
  UpdateFederationPeerRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update federation peer
 * Updates the configuration of an existing federation peer. Changes to trust level or data policy take effect immediately.
 */
export async function UpdateFederationPeer(
  peer_id: string,
  data: UpdateFederationPeerRequest,
  options?: RequestOptions
): Promise<FederationPeerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.put<FederationPeerResponse>(requestPath, data, requestOptions);
}
